const BASE_URL = process.env.REACT_APP_BOOKS_EXAMPLE_JSON;

export const getBookIds = async () => {
  try {
    const response = await fetch(BASE_URL, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
      },
    }).then(res => res.json());
    return response;
  } catch (error) {
    console.log('error:', error);
  }
};
